import React from 'react';
import { useAppContext } from '../contexts/AppContext';
import { buildPathProgress, shouldShowReturningPath, applySeedlessStart, openPathRoom } from '../utils/pathHome';
import StTalkHome from './StTalkHome';
import PathHome from '../components/PathHome';

/**
 * Talk tab. Zero saved chapters, and every gift book, keep today's doorway.
 * An own-story book with at least one chapter lands on Path.
 * While the book record is still loading, hold a quiet spinner so a returner
 * does not flash the first-time door.
 */
const OwnStoryHome = () => {
  const ctx = useAppContext();
  const { isGiftBook, userDataLoaded, stBookPages, stories, loadingStories } = ctx;

  if (!userDataLoaded) {
    return (
      <div data-testid="talk-home-loading" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', background: '#FBF8F1' }}>
        <div style={{ width: 34, height: 34, border: '3px solid rgba(201,168,76,0.25)', borderTopColor: '#D2761F', borderRadius: '50%', animation: 'tbspin 0.8s linear infinite' }} />
        <style>{`@keyframes tbspin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  const progress = buildPathProgress({
    pages: stBookPages,
    stories,
    storiesLoaded: !loadingStories,
  });

  if (!shouldShowReturningPath({ isGiftBook, userDataLoaded: true, chapterCount: progress.chapterCount })) {
    return <StTalkHome />;
  }

  return (
    <PathHome
      progress={progress}
      onJustTalk={() => applySeedlessStart(ctx)}
      onOpenPack={(packId) => openPathRoom(ctx, packId)}
    />
  );
};

export default OwnStoryHome;
